const handleDeleteDocumentFileModalAction = {
  confirm: 'Do you really want to delete this file?',
  title: 'DELETE FILE'
};

export default handleDeleteDocumentFileModalAction;
